// src/countryList.js
const countryList = [
    "Italy", "France", "Germany", "Spain", "United States", "Canada",
    "United Kingdom", "Australia", "Brazil", "China", "Japan", "India",
    "Mexico", "South Africa", "Russia", "Netherlands", "Sweden", "Norway",
    "Argentina", "Switzerland", "Poland", "Ukraine", "United Arab Emirates",
    "Israel", "Singapore", "South Korea", "Thailand", "Vietnam",
    "Indonesia", "Turkey", "Portugal", "Greece", "Belgium", "Austria",
    "Denmark", "Finland", "Ireland", "Hungary", "Romania", "Chile",
    "Colombia", "Peru", "Egypt", "Morocco", "Tunisia", "Nigeria", "Kenya",
    "New Zealand", "Philippines", "Malaysia", "Pakistan"
  ];
  
  export default countryList;
  